class HeaderMenu {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      $('.js-h-content a').on('click', function() {
        $('html').removeClass('is-open');
        scrollBan();
      });

      $('.js-mega-trigger').on('click', function() {
        $(this).toggleClass('is-active');
        $(this).next('.js-mega-content').slideToggle();
      });

    } else {
      $('.js-mega-trigger').hover(function() {
        $(this).addClass('is-active');
        $(this).next('.js-mega-content').addClass('is-active');
      }, function() {
        $(this).removeClass('is-active');
        $(this).next('.js-mega-content').removeClass('is-active');
      });

      $('.js-mega-content').hover(function() {
        $(this).addClass('is-active');
        $(this).prev('.js-mega-trigger').addClass('is-active');
      }, function() {
        $(this).removeClass('is-active');
        $(this).prev('.js-mega-trigger').removeClass('is-active');
      });
    }
    
    $(window).scroll(function () {
      if ($(window).scrollTop() > 20) {
        $('html').addClass('is-scroll');
      } else {
        if (!$('html').hasClass('is-open')) {
          $('html').removeClass('is-scroll');
        }
      }
    });
    
    $('.js-drawer').click(function () {
      $('html').toggleClass('is-open');
      scrollBan();
    });

    let scrollTop = 0;

    function scrollBan() {
      const body = $('html')[0];
      if (body.classList.contains('is-hidden')) {
        body.style.scrollBehavior = 'auto';
        body.style.top = '';
        body.classList.remove('is-hidden');
        window.scrollTo(0, scrollTop);
        setTimeout(() => body.style.scrollBehavior = 'smooth', 0);
      } else {
        scrollTop = window.scrollY;
        body.style.top = (scrollTop * -1) + 'px';
        body.classList.add('is-hidden');
      }
    }
  }
}